// @ts-ignore
import { useContext, useState, useEffect, useRef } from "react";

import useAxiosREST from "/utils/hooks/useAxiosAPI";
// @ts-ignore
import Leaderboard from "./section/leaderboard";
import { useAnimation } from "/context/AnimationProvider";
import About from "./section/about";
import Bundles from "./section/bundles";
import Rewards from "./section/rewards";
import FAQ from "./section/faq";
import Introducing from "./section/introducing";

// @ts-ignore
export default function Home({ state, ...props }) {
  const { fetchAPI } = useAxiosREST();
  const { setPageLoading, setEvent, timerData } = useAnimation();
  const [leaderboard, setLeaderboard] = useState({});
  const [tournament, setTournament] = useState(null);
  const [faqList, setfaqList] = useState([]);
  const isLoading = useRef(false);
  const activePageRef = useRef(0);
  const isFaqLoaded = useRef(false);

  const TOURNAMENT = "tournaments/uniswap-cup-gripai-fair-play-week";

  const isEventEnded = timerData.isEnded;

  const getTournament = async () => {
    const tournament = await fetchAPI.get(TOURNAMENT);
    if (tournament?.not_found || !tournament?.uuid) return;
    setEvent(tournament);
    setTournament(tournament);
  };

  const getLeaders = async (toPage) => {
    if (isLoading.current) return;

    const page = toPage ?? activePageRef.current + 1;
    // @ts-ignore
    const maxPage = window.last_load_page;

    try {
      if (leaderboard[page]) {
        activePageRef.current = page;
        // @ts-ignore
        window.active_page = page;
        return;
      }
      if (page > maxPage) {
        return;
      }
      isLoading.current = true;
      const data = await fetchAPI.get(`${TOURNAMENT}/leaderboard?page=${page}`);
      if (!data?.meta || data?.not_found) {
        setLeaderboard(null);
        return;
      }
      setLeaderboard((prev) => ({ ...prev, [page]: data }));
      activePageRef.current = page;
      // @ts-ignore
      window.active_page = page;
      // @ts-ignore
      window.last_load_page = data.meta.last_page;
    } catch (error) {
    } finally {
      isLoading.current = false;
    }
  };

  const getFAQList = async () => {
    try {
      // if (isFaqLoaded.current) return;
      // isEventEnded && (isFaqLoaded.current = true);
      const response = await fetch(
        // `/faq/faq${isEventEnded ? "-ended" : ""}.json`
        `/faq/faq-funtico.json`
      );
      const data = await response.json();
      setfaqList(data);
    } catch (error) {}
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([getTournament(), getLeaders(), getFAQList()]);
      setPageLoading(false);
    };

    fetchData();
    return () => {};
  }, []);

  return (
    <>
      <About isEnded={isEventEnded} />
      {<Bundles />}
      <Leaderboard
        leaderboard={leaderboard}
        getLeaders={getLeaders}
        activePage={activePageRef.current}
        isLoading={isLoading.current}
        isEnded={isEventEnded}
      />
      {/* <Rewards isEnded={isEventEnded} /> */}
      <Introducing tournament={tournament} isEnded={isEventEnded} />
      <FAQ faqList={faqList} isEnded={isEventEnded} />
    </>
  );
}
